import React, { useContext } from 'react';
import { tokens } from '@welbe/web-design-system';

import { BalloonHeartIcon } from '../BalloonHeartIcon/BalloonHeartIcon';
import { Container, Text } from './InfoLabel.styles';
import { I18nProviderContext } from 'contexts/I18nProvider';

export const InfoLabel = () => {
	const { translate } = useContext(I18nProviderContext);

	return (
		<Container>
			<BalloonHeartIcon color={tokens.color_success} />
			<Text>
				{translate('views.campaigns.evaluations.progress.labelDescription')}{' '}
				<a
					target="_blank"
					href="https://www.dof.gob.mx/nota_detalle.php?codigo=5541828&fecha=23/10/2018#gsc.tab=0"
					rel="noreferrer"
				>
					{translate('commons.moreInfo')}
				</a>
			</Text>
		</Container>
	);
};
